import { render, staticRenderFns } from "./RequestDetails_old.vue?vue&type=template&id=1c645464"
import script from "./RequestDetails_old.vue?vue&type=script&lang=js"
export * from "./RequestDetails_old.vue?vue&type=script&lang=js"
import style0 from "./RequestDetails_old.vue?vue&type=style&index=0&id=1c645464&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports